import React from "react";
import { PANEL_CLASS } from "./uiConstants";

type EventLogSectionProps = {
  entries: string[];
};

const EventLogSection: React.FC<EventLogSectionProps> = ({ entries }) => (
  <section className={`${PANEL_CLASS} p-6`}>
    <h3 className="text-xl font-bold text-slate-900">Event Log</h3>
    <div
      id="log-content"
      className="mt-3 h-64 overflow-y-auto border-2 border-black bg-[#faf3e2] p-3 text-sm leading-relaxed text-slate-800"
    >
      {entries.map((entry, index) => (
        <p key={index}>{entry}</p>
      ))}
    </div>
  </section>
);

export default EventLogSection;
